module.exports = require("core-js/library/fn/object/get-prototype-of");